import Api from "../../api/Api";
import { toast } from "react-toastify";
import {
  ADD_APPLE2FA_SUCCESS,
  DELETE_APPLE2FA_SUCCESS,
  GET_APPLE2FA_SUCCESS,
  UPDATE_APPLE2FA_SUCCESS,
} from "./actionTypes";

const getListParams = (params, state) => ({
  page: params.page ?? state?.pagination?.page ?? 1,
  per_page: params.per_page ?? state?.pagination?.per_page ?? 10,
  search: params.search ?? state?.pagination?.search ?? "",
  scope: params.scope ?? "list",
  silent: params.silent ?? false,
});

const getResponseBody = (response) => response?.data ?? response;

const toList = (value) => (Array.isArray(value) ? value : []);

const buildSuccessPayload = (response, { search, scope }) => {
  const data = getResponseBody(response);
  const items = toList(data.data);

  const payload = {
    total: data.total ?? items.length,
    page: data.page ?? 1,
    per_page: data.per_page ?? 10,
    search,
    scope,
  };

  if (scope === "defective") {
    payload.defective = items;
  } else {
    payload.apples = items;
  }

  return payload;
};

const reloadApple2faList = (dispatch, getState, overrides = {}) => {
  const { pagination } = getState().APPLE2FA;
  dispatch(
    loadApple2fa({
      page: pagination?.page ?? 1,
      per_page: pagination?.per_page ?? 10,
      search: pagination?.search ?? "",
      scope: "list",
      silent: true,
      ...overrides,
    })
  );
};

export const loadApple2fa = (params = {}) => (dispatch, getState) => {
  const listState = getState().APPLE2FA;
  const { page, per_page, search, scope, silent } = getListParams(
    params,
    listState
  );

  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;

  const req = Api.get("/apple2fa/get", {
    params: { page, per_page, search, scope },
  });

  const onSuccess = (data) => {
    dispatch({
      payload: buildSuccessPayload(data, { search, scope }),
      type: GET_APPLE2FA_SUCCESS,
    });
  };

  if (silent) {
    req.then((response) => onSuccess(response)).catch(() => {});
    return;
  }

  toast.promise(req, {
    pending: "Getting Apple IDs...",
    success: {
      render({ data: response }) {
        onSuccess(response);
        return "Your Data Is Ready";
      },
    },
    error: {
      render() {
        return "An error occurred while getting Apple IDs";
      },
    },
  });
};

export const addApple2fa = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/add", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadApple2faList(dispatch, getState, { page: 1 });
        return "Apple ID added successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const updateApple2fa = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/update", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_APPLE2FA_SUCCESS,
        });
        reloadApple2faList(dispatch, getState);
        return "Apple ID updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your Apple ID";
      },
    },
  });
};

export const deleteApple2fa = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadApple2faList(dispatch, getState);
        return "Apple ID deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your Apple ID";
      },
    },
  });
};

export const soldApple2fa = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/sold", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadApple2faList(dispatch, getState);
        return "Apple ID updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your Apple ID";
      },
    },
  });
};

export const importApple2fa = (data) => (dispatch, getState) => {
  const formData = new FormData();
  formData.append("file", data.file);

  let req = Api.post("/apple2fa/import", formData, {
    headers: {
      Authorization: "Bearer " + getState().login.token,
    },
  });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadApple2faList(dispatch, getState, { page: 1, search: "" });
        return "Apple ID imported successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const exportApple2fa = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/export", { number: data.formData.number });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render(response) {
        reloadApple2faList(dispatch, getState, { page: 1 });
        window.open(response.data.data, "_blank");
        return "Apple ID exported successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const exportApple2faQr = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/export/qr", {
    number: data.number,
    image: data.image,
    shownote: data.shownote,
    note: data.note,
  });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render(response) {
        reloadApple2faList(dispatch, getState, { page: 1 });
        window.open(response.data.data, "_blank");
        return "Apple ID exported successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const fixApple = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/fix", { accounts: data.formData.accounts });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadApple2faList(dispatch, getState, { page: 1 });
        return "Apple IDs fixed successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const deleteAppleDefective = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/apple2fa/delete/defective", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        dispatch(
          loadApple2fa({
            scope: "defective",
            page: getState().APPLE2FA.pagination?.page ?? 1,
            per_page: getState().APPLE2FA.pagination?.per_page ?? 10,
            search: getState().APPLE2FA.pagination?.search ?? "",
            silent: true,
          })
        );
        return "Apple ID deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your Apple ID";
      },
    },
  });
};
